import { FormInput } from '@systemeio/ui'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { useUpdateXenditIntegration } from 'modules/profile/payment-gateways/integrations/xendit/hooks'
import {
  XenditIntegrationErrorsInterface,
  XenditUpdateIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/xendit/types'
import React, { useState } from 'react'
import EditModal from 'shared/components/edit-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

interface XenditEditModalProps {
  details: XenditUpdateIntegrationInterface
}

const defaultErrors: XenditIntegrationErrorsInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: '',
}

const XenditEditModal = ({ details }: XenditEditModalProps) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)

  const { updateXenditIntegration } = useUpdateXenditIntegration()

  const { mutatePaymentIntegrations } = useConnectedPaymentIntegrations()

  const onEdit = async (data: XenditUpdateIntegrationInterface) => {
    await fetchWithErrors(async () => {
      await updateXenditIntegration(data)
      await mutatePaymentIntegrations()
    }, setErrors)
  }

  return (
    <>
      <button className={'primary-link flex justify-start'} onClick={() => setOpened(true)}>
        {t('global.settings')}
      </button>
      <EditModal
        fullCaption={`${t('global.edit')} ${t(
          'dashboard.settings.payment-gateways.xendit_integration',
        ).toLowerCase()} `}
        opened={opened}
        onClose={() => {
          setOpened(false)
        }}
        instance={details}
        editable={[
          {
            field: 'organizationName',
            onRender: (value, onChange) => (
              <FormInput
                key={'xendit-organization-name-edit'}
                label={t('dashboard.settings.payment-gateways.organization_name')}
                value={value}
                onChange={e => onChange(e.target.value)}
                required
                error={errors.organizationName}
              />
            ),
          },
          {
            field: 'webhookSecret',
            onRender: (value, onChange) => (
              <FormInput
                key={'xendit-webhook-secret-edit'}
                label={t('dashboard.settings.payment-gateways.webhook_secret')}
                value={value}
                onChange={e => onChange(e.target.value)}
                required
                error={errors.webhookSecret}
              />
            ),
          },
        ]}
        onEdit={data => onEdit(data)}
      />
    </>
  )
}

export default XenditEditModal
